<div class="scroll-top__container hide-print" [ngClass]="{ 'opac-0': !show, 'opac-1': show }">
  <a (click)="onScrollToTop()" (keyup.enter)="onScrollToTop()" class="scroll-top" tabindex="0" role="link" aria-labelledby="Scroll to top">
    <mat-icon aria-labelledby="Scroll to top"> arrow_upward </mat-icon>
    Top
  </a>
</div>
